export const Pages = {
  Home: '/',
  Clients: '/clients',
  Login: '/login',
};
